import { Component, OnInit } from '@angular/core';
import {  Router } from '@angular/router';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { ActionsService } from 'src/app/modules/common/_services/actions.service';
import { AutomationsActionsService } from 'src/app/modules/common/_services/automations-actions.service';
import { AutomationsEventsService } from 'src/app/modules/common/_services/automations-events.service';
import { Action } from 'src/app/modules/common/_types/action';
import { AutomationAction } from 'src/app/modules/common/_types/automation-action';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-automations-actions-detail',
    templateUrl: './automations-actions-detail.component.html',
    styleUrls: ['./automations-actions-detail.component.css'],
    standalone: false
})
export class AutomationsActionsDetailComponent implements OnInit {
  public automationActionFormGroup!: RxFormGroup;
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public actions: Action[] = [];
  public automationAction: AutomationAction = new AutomationAction();
  public automationActionConfig: any = {
    values: {}
  };

  
  constructor(
    private actionsService: ActionsService,
    private router: Router,
    private formBuilder: RxFormBuilder,
    private config: DynamicDialogConfig,
    private automationsActionsService: AutomationsActionsService,
    private formValidationService: FormValidatorService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogRef: DynamicDialogRef,
    private loginService: LoginService
  ) {
    this.automationActionFormGroup = this.formBuilder.formGroup<AutomationAction>(this.automationAction) as RxFormGroup;
   }

  ngOnInit() {
    
    if (this.config.data.id) {
      this.automationAction.id = this.config.data.id;
      this.loadData(this.automationAction.id as string);
    }else if(this.config.data.automationId){
      this.automationAction.automationId = this.config.data.automationId;
      this.automationActionFormGroup.patchValue(this.automationAction);
    }
    
    this.allowWrite = this.loginService.hasPermission('AUTOMATIONS.WRITE');;
    this.allowDelete = this.loginService.hasPermission('AUTOMATIONS.DELETE');;
    this.loadActions();
  }

  async loadData(id: string){
    this.automationAction = await firstValueFrom(this.automationsActionsService.get(id, { include: ['action'] }));
    this.automationActionFormGroup.patchValue(this.automationAction);

     //Mostramos la información del evento
      if(this.automationAction.actionId != null){
        this.automationAction.action.eventConfig.fields.map(async (element:any) => {
          // ⚡ Si tiene SQL, carga las opciones desde el servidor
          if (element?.optionsSql) {
            element.optionsItems = await this.loadDropdownOptions(this.automationAction.actionId as string, element.name);                        
          }
          if(element.inputType == "bool"){
            this.automationActionConfig.values[element.name] = this.automationAction.actionConfig.values[element.name] == "1" ? true : false;
          }else if(element.inputType == "multiselect"){
            this.automationActionConfig.values[element.name] = this.automationAction.actionConfig.values[element.name].split(",");
          }else{
            this.automationActionConfig.values[element.name] = this.automationAction.actionConfig.values[element.name];
          }
        });       
      }

  }

  
  async loadAutomationAction($event:any){
    let response = await firstValueFrom(this.actionsService.get($event.value));
    this.automationAction.action = response;
    
    this.automationAction.action.eventConfig.fields.map(async (element:any) => {
      // ⚡ Si tiene SQL, carga las opciones desde el servidor
      if (element?.optionsSql) {
        element.optionsItems = await this.loadDropdownOptions(this.automationAction.actionId as string, element.name);                        
      }else{
        this.automationActionConfig.values[element.name] = element.value;
      }
    });
  }

  
  async loadDropdownOptions(id: string, name: string){    
    let response = await firstValueFrom(this.actionsService.getDropdownOptions(id, name));         
    return response.result;
  }


  async loadActions(){
    let response = await firstValueFrom(this.actionsService.all());
    this.actions = response.data;
  }

  
  cancel() {
    this.dynamicDialogRef.close();
  }
  
  convertArrayValuesToString(obj: any): any {
    if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        if (key === 'value' && Array.isArray(obj[key])) {            
          obj[key] = obj[key].join(',');
        } else if(Array.isArray(obj[key])) {            
          obj[key] = obj[key].join(',');
        } else if(typeof obj[key] === 'boolean'){
          obj[key] = obj[key] ? "1" : "0";
        }  else if(typeof obj[key] === 'number'){
          obj[key] = obj[key] + "";
        } else if (typeof obj[key] === 'object') {
          this.convertArrayValuesToString(obj[key]);
        }
      }
    }
    return obj;
  }
  async save(){
    let valid = this.formValidationService.validateForm(this.automationActionFormGroup);
    if (valid) {
      this.automationAction = Object.assign(this.automationAction, this.automationActionFormGroup.value);
      if(this.automationAction.actionConfig==null) this.automationAction.actionConfig = {};
      this.automationAction.actionConfig.values = this.convertArrayValuesToString(this.automationActionConfig.values);
      await firstValueFrom(this.automationsActionsService.save(this.automationAction));
      this.messageService.add({ closable: true, severity: 'success', summary: "Acción guardada correctamente." });
      this.cancel();
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  delete(){
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la acción?",
      header: "Eliminar",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.automationsActionsService.delete(this.automationAction.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Acción eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }
}
